import React from 'react';
import ReactDOM from 'react-dom';

import Select, { components } from 'react-select';


class MultiSelect extends React.Component {
  constructor (props){
    super(props)
    this.options = this.props.options

    this.findValue = this.findValue.bind(this)
    this.onChange = this.onChange.bind(this)
    
    this.value = this.findValue()
  }

  findValue() {
    /*
    This method is used when the value prop is a string with multiple values separated by comma.
    In that case we split the string and search the coresponding object in the options array 
    and we add this object to the defaultValue list 
    */
      // set multiple default value
      let defaultValue = []
      let values = this.props.value;
      if(values != undefined && values) {
        if (typeof values === 'string' || values instanceof String) {
          values = values.split(',')
  
          // search every value in all options
          for(let i=0; i<values.length; i++) {
            let value = values[i];
  
            // defaultValue.push(this.findValue(values[i])
            // search every value in options
            for(let j=0; j < this.options.length; j++) {
              if(value == this.options[j].value) {
                defaultValue.push(this.options[j])
              }
  
              // if one Object has suboptions search in suboptions
              if(this.options[j].hasOwnProperty("options")) {
                for(let suboption=0; suboption < this.options[j].options.length; suboption++) {
                  let suboptionObj = this.options[j].options[suboption]
                  if(value == suboptionObj.value) {
                    defaultValue.push(suboptionObj)
                  }
                }
              }
            }
          }
        } else {
          defaultValue = values;
        }
      }
      return defaultValue;
  }

  onChange(value) {
    // components without parents need an internal state
    this.value = value;

    // call the parent onChange method, received as prop
    if(this.props.onChange != undefined){
      this.props.onChange(value);  
    }

    // because we don't change the state we need to force rerendering
    this.forceUpdate();
  }
  
  render() {
    if(this.props.externalValue != undefined){
      this.value = this.findValue()
    }

    return (
        <Select 
          name={this.props.name} 
          options={this.options} 
          value={this.value} 
          onChange={this.onChange} 
          isSearchable={true} 
          isClearable={true} 
          isMulti />
    );
  }
}

export default MultiSelect